<template>
  <transition name="fade" mode="out-in">

    <v-container
        v-if="activeMessage"
        class="d-flex align-center data-editor-feedback"
        :class="activeMessageSeverity"
        v-on:click.prevent="closeNotification">
      <v-icon v-if="notificationIcon" color="white" class="pr-3">
        {{ notificationIcon }}
      </v-icon>
      <div class="feedback-text">
        {{ activeMessage.text }}
      </div>
    </v-container>

  </transition>
</template>

<script>
export default {
  name: 'DataEditorFeedback',

  props: {
    resource: {
      type: String,
      default: null
    },
    autoCloseAfterMillis: {
      type: Number,
      default: 0
    }
  },

  computed: {
    baseClasses () {
      return (this.activeMessage) ? `data-editor-feedback ${this.activeMessage.severity}` : 'data-editor-feedback'
    },
    activeMessage () {
      const message = (this.resource) ? this.$store.getters['sh/itemEditingFeedback'](this.resource) : null
      if (message) this.applyAutoClose(message)
      return message
    },
    activeMessageSeverity () {
      return this.activeMessage.severity || 'success'
    },
    autoCloseDelay () {
      return (this.autoCloseAfterMillis && this.autoCloseAfterMillis > 0) ? this.autoCloseAfterMillis : false
    },
    notificationIcon () {
      const severity = (this.activeMessage) ? this.activeMessage.severity : ''
      switch (severity) {
        case 'info': return 'info'
        case 'warning': return 'info'
        case 'error': return 'warning'
        case 'success': return 'check_circle'
        default: return 'check_circle'
      }
    }
  },

  methods: {
    closeNotification () {
      if (this.activeMessage && this.resource) {
        return this.$store.dispatch('sh/resolveMessageForItemEditing', this.resource)
      }
      return false
    },
    applyAutoClose (message) {
      if (message && this.autoCloseDelay) {
        setTimeout(() => {
          this.closeNotification()
        }, this.autoCloseDelay)
      }
    }
  }
}
</script>

<style scoped>

.data-editor-feedback {
  cursor: pointer;
}

.data-editor-feedback .feedback-text {
  color: #FFFFFF;
  font-weight: 400;
  font-size: 1.06rem;
}

.data-editor-feedback.success {
  border-color: #47C796;
  color: #47C796;
}

.data-editor-feedback.error {
  border-color: #F04545;
  color: #F04545;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>
